import { render, staticRenderFns } from "./HpCenterColumnWidget.vue?vue&type=template&id=5124ab2e&"
import script from "./HpCenterColumnWidget.vue?vue&type=script&lang=js&"
export * from "./HpCenterColumnWidget.vue?vue&type=script&lang=js&"
import style0 from "./HpCenterColumnWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports